<template>
<footer class="mt_1">
    <div class="container">

        <div class="row mx_0_5">
            <div class="col_12 col_sm_4 p_0_5">
                <span>TAEGUK Essen e.V. &copy; 2025</span>
            </div>
            <div class="col_12 col_sm_8 p_0_5 text_end">
                <span class="nav_link" @click="$emit('edit-consent')">Einwilligung ändern</span>
                | <router-link :to="{ name: 'datenschutz' }" active-class="active" class="nav_link">Datenschutz</router-link>
                | <router-link :to="{ name: 'impressum' }" active-class="active" class="nav_link">Impressum</router-link>
            </div>
        </div>
        
    </div>
</footer>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'Footer'
});
</script>
